import React, { useState, useEffect } from 'react'
import { ConfigContext } from './context'
import { isFalsyOrEmpty } from '../../components/helpers/object'
import axios from 'axios'
import dayjs from 'dayjs';
import { ServiceInfo } from '../../services/dto/serviceinfo.dto';
import {version} from '../../../package.json'

export const ConfigProvider = ({children}) => {
  const [config, setConfig] = useState();
  const [loadedpalette, setLoadedPalette] = useState(false);
  const [palette, setPalette] = useState();

  useEffect(() => {
    LoadAll();
  }, [])

  const LoadAll = async () => {
    GetConfiguration();
    GetResources();
    GetPalette();
    GetVersion();
  }

  async function GetConfiguration() {
    await axios({
      method: 'get',
      url: './config.json',
      responseType: 'json'
    })
    .then(res => { 
      axios({
        method: 'get', 
        url: res.data.configurl + "config.json?apa=" + Date.now(),
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
         },
        responseType: 'json'
      })
      .then(rez => { 
        if (!isFalsyOrEmpty(config))
        {
          if (JSON.stringify(config) !== rez.data)
            setConfig(rez.data);
        }
        setConfig(rez.data);
      })
      .catch(err => console.log(err))
    })
  }

const GetPalette = async () => {
  return await axios({
    method: 'get',
    url: './theme.json',
    responseType: 'json'
  })
  .then(res => { setPalette(res.data); setLoadedPalette(true);})
}

const GetResources = async () => {
    await axios({
      method: 'get',
      url: './config.json',
      responseType: 'json'
    })
    .then(rez => {
        axios({
          method: 'get', 
          url: rez.data.configurl + "offices.json?apa=" + Date.now(),
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            },
          responseType: 'json'
        }).then(rex => {
          if (!isFalsyOrEmpty(rex))
            sessionStorage.setItem("resources", JSON.stringify(rex.data));
        })
    })
    .catch(error => console.log(error))
}

const GetVersion = () => {
  var stored = localStorage.getItem("version");
  var newversion = version;
  console.log("VERSION CONTROL")
  if (isFalsyOrEmpty(stored) || stored === "undefined")
  {
    console.log("NO VERSION FOUND")
    localStorage.setItem("version", newversion);
    localStorage.removeItem("language");
    window.location.reload();
  }
  else
  {
    if (stored < newversion)
    {
      console.log("OLD VERSION FOUND")
      localStorage.removeItem("version");
      localStorage.removeItem("language");
      window.location.reload();
    }
    console.log("CURRENT VERSION FOUND")
  }
}

// Vad ska den här klassen/interfejset göra?
// Vi ska kunna kolla vilka köer som ska vara öppna för vilka kontor, under vilka dagar och timmar.
// Sedan ska vi filtrera bort de resultat som inte faller innom ramarna

// Det som kommer in är en lista på köer (queues) samt ett kontors-ID (officeID).
// Vår referens är en json-fil över kontor, med kö-information. (resource)
// Vi slår upp kontoret i "resource" och kollar vilka köer som finns där
// Första sorteringen är ifall köerna i "queues" finns med i "resources"
// Andra sorteringen är att kolla ifall gala/nqc informationen under "resources" matchar informationen i "queues"
// Tredje sorteringen är att kolla ifall det är rätt dag
// Fjärde sorteringen är att kolla ifall det är rätt tid på dagen
// Varje gång som ett entry i "queues" failar så tar vi bort den ur listan och går vidare till nästa objekt, tills vi returnerar något

const Queuefilter = async (officeID, queues) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID && queues)
  {
    const offices = tmpresources["offices"].find(x => x.id === officeID);
    if (offices)
    {
      const qs = offices["queues"];
      const queuetemplates = offices["queuetemplates"];
      var templateresults = queuetemplates.map(x => GetTemplate("queue", x));
      var queueresource = templateresults.concat(qs);
      if (queueresource)
      {
        const day = dayjs().format('ddd').toLowerCase();
        const hour = dayjs().format('H');
        const minute = dayjs().format('m');
        // var kek = queueresource.map(x => x.openhourtemplates.map(a => GetTemplate("openhour", a)))
        // var fef = kek.flat();
        // var beb = kek.concat(queueresource.map(x => x.openhours).filter(x => !isFalsyOrEmpty(x))).flat();
        // var fuf = kek.concat(beb)
        const firstfilter = queues.filter(x => 
                              queueresource.find(
                              ((y,i) => (y.id === x.queueID
                              || (y.gala_segment === x.segmentID && y.gala_service === x.serviceID))
                              && y.openhourtemplates.map(a => GetTemplate("openhour", a)).flat().concat(y.openhours).filter(x => !isFalsyOrEmpty(x)).some(z => z.days.some(a => a === day) 
                              && dayjs().hour(z.open_hour).minute(z.open_minute).isBefore(dayjs().hour(hour).minute(minute)) 
                              && dayjs().hour(z.close_hour).minute(z.close_minute).isAfter(dayjs().hour(hour).minute(minute)) 
                              ))));
        return firstfilter;
      }
    }
  }
  else return null;
}

const UpdateQueueDataFromConfig = (officeID, queuedata) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  var updatedqueues = null;
  try {
    const office = tmpresources["offices"].find(x => x.id === officeID);
    if (isFalsyOrEmpty(office))
      return null;
    const qtemplates = office["queuetemplates"];
    const qs = qtemplates.map(x => GetTemplate("queue", x));
    const queues = qs.concat(office["queues"]).filter(x => queuedata.find(y => y.queueID === x.id));
    updatedqueues = queues.map(x => { 
      var q = queuedata.find(y => y.queueID === x.id);
      return new ServiceInfo(x.name, q.peopleWaiting, q.actualWaitTime, q.active, q.queueID, x.gala_service, x.gala_service);
    });
  }
  catch{

  }
  return updatedqueues;
}

const GetOfficeIDFromUrlID = urlid => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    const result = tmpresources["offices"].find(x => x.urlid.toString() === urlid);
    if (result)
      return result.id;
  }
  else
    return null;
}

const GetUrlIDFromOfficeID = officeid => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    const result = tmpresources["offices"].find(x => x.id === officeid);
    if (result)
      return result.urlid;
  }
  else
    return null;
}

const GetQueueIDfromUrlID = (oid, qid) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    var office = tmpresources["offices"].find(x => x.id === oid);
    const templatenames = office["queuetemplates"];
    var templateresults = templatenames.map(x => GetTemplate("queue", x));
    var queues = office["queues"];
    const result = templateresults.concat(queues).find(x => x.urlid.toString() === qid);
    if (result)
      return result.id;
  }
  else
    return null;
}

const GetUrlIDFromQueueID = (oid, qid) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    var office = tmpresources["offices"].find(x => x.id === oid);
    const templatenames = office["queuetemplates"];
    var templateresults = templatenames.map(x => GetTemplate("queue", x));
    const result = templateresults.concat(office["queues"]).find(x => x.id === qid);
    if (result)
      return result.urlid;
  }
  else
    return null;
}

const GetQueuenameFromQueueID = (oid, qid) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources))
  {
    var office = tmpresources["offices"].find(x => x.id === oid);
    const templatenames = office["queuetemplates"];
    var templateresults = templatenames.map(x => GetTemplate("queue", x));
    const result = templateresults.concat(office["queues"]).find(x => x.id === qid);
    if (result)
      return result.name;
  }
  else
    return null;
}

const GetPrinterData = async officeID => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID)
  {
    const offices = tmpresources["offices"].find(x => x.id === officeID);
    if (offices)
    {
      const printerNumber = offices["NQCPrinterNumber"];
      const printerTextNumber = offices["NQCPrinterTextNumber"];
      if (printerNumber && printerTextNumber)
        return { printerNumber, printerTextNumber };
      else
        return null;
    }
  }
}

const CheckIfHasForm = ( officeID, serviceinfo ) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID && serviceinfo)
  {
    const office = tmpresources["offices"].find(x => x.id === officeID);
    if (office)
    {
      const templatenames = office["queuetemplates"];
      var templateresults = templatenames.map(x => GetTemplate("queue", x));
      var servicetype = templateresults.concat(office["queues"]).find(x => x.id === serviceinfo.queueID || (x.gala_segment === serviceinfo.segmentID && x.gala_service === serviceinfo.serviceID));
      if (servicetype && servicetype.hasforms === true)
        return true;
    }
  }
  return false;
}

const GetFormData = ( officeID, serviceinfo ) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  if (!isFalsyOrEmpty(tmpresources) && officeID && serviceinfo)
  {
    const office = tmpresources["offices"].find(x => x.id === officeID.toString());
    if (office)
    {
      const templatenames = office["queuetemplates"];
      var templateresults = templatenames.map(x => GetTemplate("queue", x));
      var servicetype = templateresults.concat(office["queues"]).find(x => x.id === serviceinfo.queueID || (x.gala_segment === serviceinfo.segmentID && x.gala_service === serviceinfo.serviceID));
      if (servicetype && servicetype.hasforms === true)
      {
        var templates = GetTemplate("form", servicetype.formtemplate);
        return templates.concat(servicetype.forms).flat();
      }
    }
  }
  return null;
}

const GetTemplate = (type, name) => {
  let tmpresources = JSON.parse(sessionStorage.getItem("resources"));
  let templates = tmpresources["templates"];
  let selectedtemplate;
  var item = null;
  if (type === "queue")
  {
    selectedtemplate = templates["queuetemplates"];
    if (selectedtemplate.length > 0)
      item = selectedtemplate.filter(x => x.name === name)
  }
  else if (type === "form")
  {
    selectedtemplate = templates["formtemplates"];
    if (selectedtemplate.length > 0)
      item = selectedtemplate.filter(x => x.name === name)
  }
  else if (type === "openhour")
  {
    selectedtemplate = templates["openhourtemplates"];
    if (selectedtemplate.length > 0)
      item = selectedtemplate.filter(x => x.name === name)
  }
  if (isFalsyOrEmpty(item))
  {
    return null;
  }  
  else
  {
    return item[0].value;
  }
}


  const value = {
    state: { config, loadedpalette, palette},
    actions: { Queuefilter, GetPalette, GetOfficeIDFromUrlID, GetResources, LoadAll, GetPrinterData, CheckIfHasForm, GetFormData, GetUrlIDFromOfficeID, UpdateQueueDataFromConfig, GetQueueIDfromUrlID, GetUrlIDFromQueueID, GetQueuenameFromQueueID }
  }

  return (
    <ConfigContext.Provider value = {value}>
      { children }
    </ConfigContext.Provider>
  )
}